// extracted by mini-css-extract-plugin
export default {"zoomModal":"m4-z","image":"n4-z","button":"o4-z","isOverlayShown":"p4-z"};